
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, Hotel, PlaneTakeoff, Plus } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface TravelTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

const TravelTabs: React.FC<TravelTabsProps> = ({ activeTab, onTabChange }) => {
  const isMobile = useIsMobile();
  
  return (
    <TabsList className="bg-muted/50 grid grid-cols-3 w-full mb-4">
      <TabsTrigger 
        value="travelers" 
        className="data-[state=active]:bg-white data-[state=active]:shadow-sm px-2 text-sm sm:text-base"
      >
        <Users className="h-4 w-4 mr-1 sm:mr-2" />
        <span>Travelers</span>
      </TabsTrigger>
      <TabsTrigger 
        value="transport" 
        className="data-[state=active]:bg-white data-[state=active]:shadow-sm px-2 text-sm sm:text-base"
      >
        <PlaneTakeoff className="h-4 w-4 mr-1 sm:mr-2" />
        <Plus className="h-3 w-3 absolute -top-1 -right-1" />
        <span className="hidden sm:inline">+ Flight</span>
        <span className="sm:hidden">+ Flight</span>
      </TabsTrigger>
      <TabsTrigger 
        value="hotels" 
        className="data-[state=active]:bg-white data-[state=active]:shadow-sm px-2 text-sm sm:text-base"
      >
        <Hotel className="h-4 w-4 mr-1 sm:mr-2" />
        <span>Hotels</span>
      </TabsTrigger>
    </TabsList>
  );
};

export default TravelTabs;
